import React, { PureComponent } from 'react'
import { Grid, Paper, ListItem, MenuItem } from '@material-ui/core'
import { EditableTextField, EditableSelect, EditableDateInput } from '../common/EditableComponents'
import moment from 'moment'

export default class VehicleInfo extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {}
  }
  onChange =
    (key, type = 'TEXT') =>
    (e) => {
      let value
      if (type === 'TEXT') {
        value = e.target.value
      }
      if (type === 'NUMBER') {
        value = e
      }
      if (type === 'DATE') {
        value = e.valueOf()
      }
      this.props.onChange(key, value)
    }

  isValidDate = (current) => {
    return current > moment()
  }

  render() {
    const {
      data = {},
      editMode = false,
      errors = {},
      shops = [],
      drivers = [],
      isCompliance = false,
    } = this.props
    const Id = (data.id && data.id.length && data.id.substr(data.id.length - 5)) || ''
    const isVehicle = data && data.id ? true : false

    return (
      <div>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Paper className="paper-page" style={{ paddingBottom: '5rem' }}>
              {isVehicle && (
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      ID
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <EditableTextField
                        valueToRender={Id}
                        editMode={false}
                        value={Id}
                        type="text"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
              )}
              {isVehicle && (
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      Internal ID
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <EditableTextField
                        valueToRender={data.id || ''}
                        editMode={false}
                        value={data.id || ''}
                        type="text"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
              )}
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    NickName*
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableTextField
                      valueToRender={data.nickName || ''}
                      editMode={editMode}
                      value={data.nickName || ''}
                      onChange={this.onChange('nickName')}
                      type="text"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={errors.nickName}
                      helperText={errors.nickName}
                    />
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Name*
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableTextField
                      valueToRender={data.name || ''}
                      editMode={editMode}
                      value={data.name || ''}
                      onChange={this.onChange('name')}
                      type="text"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={errors.name}
                      helperText={errors.name}
                    />
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Year*
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableTextField
                      valueToRender={data.year || ''}
                      editMode={editMode}
                      value={data.year || ''}
                      onChange={this.onChange('year')}
                      type="text"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={errors.year}
                      helperText={errors.year}
                    />
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Make*
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableTextField
                      valueToRender={data.vehicleMake || ''}
                      editMode={editMode}
                      value={data.vehicleMake || ''}
                      onChange={this.onChange('vehicleMake')}
                      type="text"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={errors.vehicleMake}
                      helperText={errors.vehicleMake}
                    />
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Model*
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableTextField
                      valueToRender={data.vehicleModel || ''}
                      editMode={editMode}
                      value={data.vehicleModel || ''}
                      onChange={this.onChange('vehicleModel')}
                      type="text"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={errors.vehicleModel}
                      helperText={errors.vehicleModel}
                    />
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Color*
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableTextField
                      valueToRender={data.color || ''}
                      editMode={editMode}
                      value={data.color || ''}
                      onChange={this.onChange('color')}
                      type="text"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={errors.color}
                      helperText={errors.color}
                    />
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    License Plate*
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableTextField
                      valueToRender={data.vehicleLicensePlate || ''}
                      editMode={editMode}
                      value={data.vehicleLicensePlate || ''}
                      onChange={this.onChange('vehicleLicensePlate')}
                      type="text"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={errors.vehicleLicensePlate}
                      helperText={errors.vehicleLicensePlate}
                    />
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Vin*
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableTextField
                      valueToRender={data.vinNo || ''}
                      editMode={editMode}
                      value={data.vinNo || ''}
                      onChange={this.onChange('vinNo')}
                      type="text"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={errors.vinNo}
                      helperText={errors.vinNo}
                    />
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Location
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableSelect
                      value={data.associatedShopId || ''}
                      onChange={this.onChange('associatedShopId')}
                      valueToRender={data.location && data.location.name}
                      editMode={editMode}
                    >
                      {shops &&
                        shops.map((shop) => {
                          return (
                            <MenuItem key={shop.id} value={shop.id}>
                              {shop.name}
                            </MenuItem>
                          )
                        })}
                    </EditableSelect>
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Default Driver*
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableSelect
                      value={data.defaultDriverEmployeeId || ''}
                      error={errors.defaultDriverEmployeeId}
                      onChange={this.onChange('defaultDriverEmployeeId')}
                      valueToRender={`${
                        (data.defaultDriver && data.defaultDriver.firstName) || ''
                      } ${(data.defaultDriver && data.defaultDriver.lastName) || ''}`}
                      editMode={editMode}
                    >
                      {drivers &&
                        drivers.map((driver) => {
                          return (
                            <MenuItem key={driver.id} value={driver.id}>{`${
                              driver.firstName || ''
                            } ${driver.lastName || ''}`}</MenuItem>
                          )
                        })}
                    </EditableSelect>
                  </Grid>
                </Grid>
              </ListItem>
              {isVehicle && isCompliance && (
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      BioTrack Transaction ID
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                      <EditableTextField
                        valueToRender={data.biotrackTransId || ''}
                        editMode={false}
                        value={data.biotrackTransId || ''}
                        type="text"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
              )}
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Insurance Expiration
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableDateInput
                      className="emp-date-picker"
                      isValidDate={this.isValidDate}
                      valueToRender={
                        (!!data.insuranceExpireDate &&
                          moment(parseInt(data.insuranceExpireDate)).format('MM/DD/YYYY')) ||
                        ''
                      }
                      editMode={editMode}
                      value={
                        (!!data.insuranceExpireDate &&
                          moment(parseInt(data.insuranceExpireDate)).format('MM/DD/YYYY')) ||
                        ''
                      }
                      onChange={this.onChange('insuranceExpireDate', 'DATE')}
                      dateFormat={'MM/DD/YYYY'}
                      closeOnSelect={true}
                      timeFormat={false}
                      inputProps={{ placeholder: 'MM/DD/YYYY' }}
                    />
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Registration Expiration
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableDateInput
                      className="emp-date-picker"
                      isValidDate={this.isValidDate}
                      valueToRender={
                        (!!data.registrationExpireDate &&
                          moment(parseInt(data.registrationExpireDate)).format('MM/DD/YYYY')) ||
                        ''
                      }
                      editMode={editMode}
                      value={
                        (!!data.registrationExpireDate &&
                          moment(parseInt(data.registrationExpireDate)).format('MM/DD/YYYY')) ||
                        ''
                      }
                      onChange={this.onChange('registrationExpireDate', 'DATE')}
                      dateFormat={'MM/DD/YYYY'}
                      closeOnSelect={true}
                      timeFormat={false}
                      inputProps={{ placeholder: 'MM/DD/YYYY' }}
                    />
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Insurance Company
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableTextField
                      valueToRender={data.insuranceCompanyName || ''}
                      editMode={editMode}
                      value={data.insuranceCompanyName || ''}
                      onChange={this.onChange('insuranceCompanyName')}
                      type="text"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Policy Number
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableTextField
                      valueToRender={data.policyNumber || ''}
                      editMode={editMode}
                      value={data.policyNumber || ''}
                      onChange={this.onChange('policyNumber')}
                      type="text"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                </Grid>
              </ListItem>
            </Paper>
          </Grid>
        </Grid>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Vehicles/VehicleInfo.js